import { useContext } from 'react';
import {
    MutationFunction,
    UseMutationOptions,
    useMutation,
} from '@tanstack/react-query';
import { AppContext } from '../sporttia/AppContext';

const resource = '/bookings';

/**
 * Hook para acceder a los recursos de 'bookings'.
 */
export default function useBookingsService() {
    const cxt = useContext(AppContext)!;

    /**
     * POST /bookings request.
     * Uses v7 API (cxt.api) instead of v8 migration API
     */
    function useCreateBooking(
        mutationOptions?: UseMutationOptions<
            unknown,
            unknown,
            {
                params: Record<string, unknown>;
            }
        >,
    ) {
        const mutationFn: MutationFunction<
            unknown,
            {
                params: Record<string, unknown>;
            }
        > = ({ params }: any) =>
            new Promise((resolve, reject) => {
                cxt.api('POST', resource, {
                    params,
                    success: (response: any) => resolve(response),
                    error: (error: any) => reject(error),
                });
            });

        return useMutation({ mutationFn, ...mutationOptions });
    }

    return {
        useCreateBooking,
    };
}
